import { render, staticRenderFns } from "./SalesPerCity.vue?vue&type=template&id=39b17702"
import script from "./SalesPerCity.vue?vue&type=script&lang=js"
export * from "./SalesPerCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports